export default __webpack_public_path__ + "images/tree-6dd007e22346a964e11ac4dfa3ec8f06.png";